if (!customElements.get('learn-blog')) {
  class LearnBlog extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.learn-blog__track');
      this.nav = this.querySelector('[data-nav]');
      this.prev = this.querySelector('[data-dir="prev"]');
      this.next = this.querySelector('[data-dir="next"]');
      if (!this.track) return;

      this.update = this.update.bind(this);
      this.onClick = this.onClick.bind(this);

      this.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.track) this.track.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
    }

    step() {
      const slide = this.track.querySelector('.learn-blog__slide');
      if (!slide) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    onClick(event) {
      const button = event.target.closest('[data-dir]');
      if (!button || button.disabled) return;
      const direction = button.dataset.dir === 'next' ? 1 : -1;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rests = this.rests();
      const now = this.track.scrollLeft;
      let target = direction > 0 ? rests.find((x) => x > now + 4) : rests.slice().reverse().find((x) => x < now - 4);
      if (target === undefined) target = direction > 0 ? this.track.scrollWidth - this.track.clientWidth : 0;
      this.track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
    }

    /* scroll positions where each card rests on its snap point */
    rests() {
      const track = this.track;
      const cs = getComputedStyle(track);
      const tr = track.getBoundingClientRect();
      const padL = parseFloat(cs.scrollPaddingLeft) || 0;
      const padR = parseFloat(cs.scrollPaddingRight) || 0;
      const max = track.scrollWidth - track.clientWidth;
      const out = [];
      Array.from(track.children).forEach((item) => {
        if (!item.offsetWidth) return;
        const r = item.getBoundingClientRect();
        const align = getComputedStyle(item).scrollSnapAlign;
        const delta = align.indexOf('end') > -1 ? r.right - (tr.right - padR) : r.left - (tr.left + padL);
        const x = Math.max(0, Math.min(max, Math.round(track.scrollLeft + delta)));
        if (!out.length || Math.abs(out[out.length - 1] - x) > 2) out.push(x);
      });
      return out;
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const fits = scrollWidth <= clientWidth + 1;
      if (this.nav) this.nav.hidden = fits;
      if (this.prev) this.prev.disabled = scrollLeft <= 1;
      if (this.next) this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  }

  customElements.define('learn-blog', LearnBlog);
}
